// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root___gBH6","title":"Images45_title__1w8Hs","images":"Images45_images__2Y0xW"};